import { reactive } from 'vue'

export interface LogEntry {
  time: string
  level: 'info' | 'warn' | 'error' | 'network'
  message: string
}

const MAX_ENTRIES = 200

const state = reactive({
  entries: [] as LogEntry[]
})

function add(level: LogEntry['level'], message: string) {
  const time = new Date().toISOString().slice(11, 23)
  state.entries.push({ time, level, message })
  if (state.entries.length > MAX_ENTRIES) {
    state.entries.splice(0, state.entries.length - MAX_ENTRIES)
  }
}

function clear() {
  state.entries.splice(0)
}

export const debugLog = {
  state,
  add,
  clear
}
